export default "__VITE_ASSET__BXThT6dP__";